import React, { Component } from 'react';
import {
	HubFooterView,
	HubHeaderView,
	HubHeroView,
	WebsiteCardsView,
} from './components/views';

class LandingHubPage extends Component {
	componentDidMount () {
		const root = document.getElementById('root');
		if (!root) return;

		// @ts-ignore
		root.style.overflow = 'visible';
	}

	componentWillUnmount () {
		const root = document.getElementById('root');
		if (!root) return;

		// @ts-ignore
		root.style.overflow = 'hidden';
	}

	render () {
		return (
			<main>
				<HubHeaderView />
				<HubHeroView />
				<WebsiteCardsView />
				<HubFooterView />
			</main>
		);
	}
}

export default LandingHubPage;



// WEBPACK FOOTER //
// ./src/LandingHubPage.js